import { createFileRoute } from '@tanstack/react-router'
import { VisitorDetailsLocationHistoryPage } from 'features/visitorDetails'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/location-history'
)({
  component: VisitorDetailsLocationHistoryPage,
})
